<template>
  <div>
    <div
      class="add-person-wrap"
      @click="$refs.addPersonPopup.showPersonPopup = true"
      v-if="personList.length <= 0 && type !== 'detail'"
    >
      <span class="iconfont">&#xe69f;</span>
      <span>添加同行人员</span>
    </div>
    <!-- 添加后的人员列表 -->
    <div class="person-list" v-else>
      <div class="person-header">
        <span>同行人员</span>
        <div
          v-if="type !== 'detail'"
          @click="$refs.addPersonPopup.showPersonPopup = true"
        >
          <span class="iconfont">&#xe69f;</span> <span>添加同行人员</span>
        </div>
      </div>
      <div
        class="person-item flex flex-vc"
        v-for="(item, index) in personList"
        :key="index"
      >
        <div class="person-avatar">
          <img :src="item.photoImg" />
        </div>
        <div class="person-info flex-1">
          <div class="person-name">{{ item.visitorName }}</div>
          <div class="person-phone">{{ item.visitorPhone }}</div>
        </div>
        <div
          class="handle"
          v-if="type !== 'detail'"
          @click="clickPersonMinus(item)"
        >
          删除
        </div>
      </div>
    </div>
    <addPersonPopup @changeItem="handleChangePersonItem" ref="addPersonPopup" />
  </div>
</template>

<script>
import addPersonPopup from './addPersonPopup'
export default {
  props: {
    id: {},
    type: {},
  },
  components: {
    addPersonPopup,
  },
  data() {
    return {
      showPersonPopup: false,
      personList: [],
      personItem: {},
    }
  },
  mounted() {
    this.getPersonList()
  },
  methods: {
    handleChangePersonItem(item) {
      this.personItem = item
      this.setPerson()
    },
    async getPersonList() {
      const { data, code } = await this.$https.getPersonList({
        visitorId: this.id,
      })
      if (code !== 200) {
        this.$toast('获取人员失败')
        return false
      }
      console.log('人员列表', data)

      this.personList = data
    },
    async setPerson() {
      const { data, msg, code } = await this.$https.setPerson({
        permitType: 0,
        visitorId: this.id,
        ...this.personItem,
        userId: this.$store.state.userId,
      })
      if (code !== 200) {
        this.$toast('添加失败')
        return false
      }
      // 更新
      this.getPersonList()
      this.$toast('添加人员成功')
    },
    clickPersonMinus(item) {
      this.$dialog
        .confirm({
          title: '温馨提示',
          message: `是否删除${item.visitorName}该人员？`,
        })
        .then(() => {
          this.delPerson(item.id)
        })
    },
    async delPerson(deleteId) {
      const { code } = await this.$https.delPerson({
        deleteId,
        id: this.id,
      })
      if (code !== 200) {
        this.$toast('删除失败')
        return false
      }
      this.$toast('删除成功')
      this.getPersonList()
    },
  },
}
</script>

<style lang="scss" scoped>
.add-person-wrap {
  background: #fff;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  height: 3.375rem;
  text-align: center;
  line-height: 3.375rem;
  margin: 1rem 1rem 0;
  border-radius: 0.75rem;
  font-size: 0.875rem;
  color: rgba(52, 151, 253, 1);
  .iconfont {
    font-size: 0.75rem;
    margin-right: 0.25rem;
  }
}
.person-list {
  margin: 1rem 1rem 0;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #ffffff;
  border-radius: 0.75rem;
  .person-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    > span {
      color: rgba(120, 132, 158, 1);
      font-size: 0.75rem;
    }
    > div {
      .iconfont {
        font-size: 0.75rem;
      }
      font-size: 0.875rem;
      color: rgba(52, 151, 253, 1);
    }
  }
  .person-item {
    padding: 1rem 0;
    margin: 0 1rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);
    margin-bottom: 0.6rem;
    &:last-child {
      border-bottom: none;
    }
    .person-name {
      color: rgba(69, 79, 99, 1);
      font-size: 1rem;
      font-weight: 400;
      margin-bottom: 0.125rem;
    }
    .person-phone {
      color: rgba(120, 132, 158, 1);
      font-size: 0.875rem;
    }
    .person-avatar {
      margin-right: 1rem;
      img {
        width: 3rem;
        height: 3rem;
        border-radius: 0.75rem;
        margin: 0 auto;
        object-fit: cover;
        display: block;
      }
    }
    .handle {
      background: rgba(233, 235, 239, 1);
      border-radius: 0.5rem;
      font-size: 0.6875rem;
      width: 5rem;
      height: 2rem;
      text-align: center;
      line-height: 2rem;
      color: rgba(120, 132, 158, 1);
    }
  }
}
</style>
